import { gql } from "@apollo/client"
import { KNOWLEDGE_CONTENT_FIELDS, UPLOAD_FIELDS } from "./knowledgeContentFragment"

export const TRAINING_MODULE_STEP_FIELDS = gql`
  fragment TrainingModuleStepFields on TrainingModuleStep {
    __typename
    ... on TrainingModuleContentStep {
      id
      name
      type
      knowledgeContent {
        ... on KnowledgeTrainingModule {
          ...KnowledgeContentFields
        }
      }
      requiredConfirmation
      confirmationMessage
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleVideoUrlStep {
      id
      name
      type
      videoUrl
      forceWatch
      description
    }
    ... on TrainingModuleVideoUploadStep {
      id
      name
      type
      videoUpload {
        id
        fileName
        key
      }
      forceWatch
      description
    }
    ... on TrainingModuleScormUploadStep {
      id
      name
      type
      scormUpload {
        id
        fileName
        key
        processing
        error {
          code
          message
        }
      }
      description
    }
    ... on TrainingModuleSelectStep {
      id
      name
      answers {
        value
        isCorrect
      }
      type
      correctAnswerRequired
      showHint
      hint
      description
      shuffleAnswer
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleMultipleChoiceStep {
      id
      name
      answers {
        value
        isCorrect
      }
      type
      correctAnswerRequired
      showHint
      hint
      description
      shuffleAnswer
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleTrueFalseStep {
      id
      name
      type
      answers {
        value
        isCorrect
      }
      correctAnswerRequired
      showHint
      hint
      description
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleOrderingStep {
      id
      name
      type
      answers {
        value
      }
      correctAnswerRequired
      showHint
      hint
      description
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleTextResponseStep {
      id
      name
      type
      answerText
      correctAnswerRequired
      showHint
      hint
      description
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleTextEntryStep {
      id
      name
      type
      required
      description
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleChecklistStep {
      id
      name
      type
      required
      answers {
        value
      }
      description
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleSingleChoiceStep {
      id
      name
      type
      required
      answers {
        value
      }
      description
      audioUpload {
        ...UploadFields
      }
    }
    ... on TrainingModuleMatchUpStep {
      id
      name
      type
      answers {
        value
        phrase
      }
      description
      correctAnswerRequired
      showHint
      hint
      audioUpload {
        ...UploadFields
      }
    }
  }
  ${KNOWLEDGE_CONTENT_FIELDS}
  ${UPLOAD_FIELDS}
`
